import React, { useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import { ToastContext } from "../App";
import { Modal, Button } from "react-bootstrap";
import { FaHistory } from "react-icons/fa"; // icon for history


import UserNavbar from "./userNavbar";

export default function Profile() {
    const showToast = useContext(ToastContext);
    const [user, setUser] = useState(null);
    const [formData, setFormData] = useState({});
    const [imagePreview, setImagePreview] = useState(null);
    const fileInputRef = useRef();
    const didFetch = useRef(false);

    const [weightHistory, setWeightHistory] = useState([]);
    const [showWeightModal, setShowWeightModal] = useState(false);


    const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api/profile`;

    const getAuthHeaders = () => {
        const token = localStorage.getItem("FORCE_GYM_TOKEN");
        return { headers: { Authorization: `Bearer ${token}` } };
    };

    useEffect(() => {
        if (!didFetch.current) {
            fetchProfile();
            didFetch.current = true;
        }
    }, []);

    const fetchProfile = async () => {
        try {
            const res = await axios.get(API_URL, getAuthHeaders());
            setUser(res.data);
            setFormData({
                full_name: res.data.full_name,
                age: res.data.age,
                birth_date: res.data.birth_date ? res.data.birth_date.split('T')[0] : "",
                phone: res.data.phone,
                weight: res.data.weight,
                height: res.data.height,
                smoker: res.data.smoker,
                goal: res.data.goal,
                health_notes: res.data.health_notes,
            });
            setImagePreview(res.data.profile_image ? `${process.env.REACT_APP_BACKEND_URL}/profile/${res.data.profile_image}` : null);
        } catch (err) {
            console.error(err);
            showToast("حدث خطأ أثناء جلب البيانات!", "danger");
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setImagePreview(URL.createObjectURL(e.target.files[0]));
        }
    };

    const handleSave = async () => {
        try {
            const data = new FormData();
            Object.keys(formData).forEach(key => data.append(key, formData[key]));
            if (fileInputRef.current.files[0]) data.append('profile_image', fileInputRef.current.files[0]);

            const res = await axios.put(API_URL, data, {
                headers: { ...getAuthHeaders().headers, "Content-Type": "multipart/form-data" },
            });
            showToast(res.data.message, "success");
            fetchProfile();
        } catch (err) {
            console.error(err);
            showToast("حدث خطأ أثناء الحفظ!", "danger");
        }
    };

    const fetchWeightHistory = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/members/${user.id}/weight-history`, getAuthHeaders());
            setWeightHistory(res.data);
            setShowWeightModal(true); // open modal
        } catch (err) {
            console.error(err);
            showToast("حدث خطأ أثناء جلب تاريخ الوزن!", "danger");
        }
    };



    if (!user) return <div className="text-center mt-5">جارٍ التحميل...</div>;

    return (
        <div
            className="container py-5"
            dir="rtl"
            style={{
                minHeight: "100vh",
            }}
        >
            <div
                className="card shadow border-0 rounded-4 p-4 mx-auto"
                style={{ maxWidth: "950px", backgroundColor: "white" }}
            >
                {/* ===== Header Row ===== */}
                <div className="row align-items-center gy-3">
                    {/* Profile info (image + name) */}
                    <div className="col-12 col-md-8 d-flex flex-column flex-sm-row align-items-center justify-content-center justify-content-md-start">
                        {/* Profile Image */}
                        <div
                            className="rounded-circle overflow-hidden border border-4 border-primary shadow-sm me-md-3 mb-3 mb-md-0"
                            style={{ width: "120px", height: "120px" }}
                        >
                            <img
                                src={imagePreview || "/images/default-user.png"}
                                alt="Profile"
                                className="w-100 h-100"
                                style={{ objectFit: "cover" }}
                            />
                        </div>

                        {/* Name */}
                        <h3 className="fw-bold  mb-0 mx-4 text-center text-md-start">
                            {formData.full_name || "اسم المستخدم"}
                        </h3>
                    </div>

                    {/* Upload Button */}
                    <div className="col-12 col-md-4 text-center text-md-end">
                        <input
                            id="fileUpload"
                            type="file"
                            ref={fileInputRef}
                            className="d-none"
                            onChange={handleImageChange}
                        />
                        <label
                            htmlFor="fileUpload"
                            className="btn btn-outline-primary fw-semibold px-4 py-2 shadow-sm"
                            style={{ borderRadius: "50px" }}
                        >
                            <i className="bi bi-upload me-2"></i> تغيير الصورة
                        </label>
                    </div>
                </div>

                <hr className="my-4" />

                {/* ===== User Details ===== */}
                <h4 className="fw-bold  mb-4 ">
                    التفاصيل الشخصية
                </h4>

                <div className="row g-3">
                    <div className="col-md-6">
                        <label className="form-label fw-semibold">الاسم الكامل</label>
                        <input
                            type="text"
                            name="full_name"
                            value={formData.full_name}
                            onChange={handleChange}
                            className="form-control form-control-lg shadow-sm"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label fw-semibold">تاريخ الميلاد</label>
                        <input
                            type="date"
                            name="birth_date"
                            value={formData.birth_date}
                            onChange={handleChange}
                            className="form-control form-control-lg shadow-sm text-end"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label fw-semibold">رقم الهاتف</label>
                        <input
                            type="text"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            className="form-control form-control-lg shadow-sm"
                        />
                    </div>

                    <div className="col-md-3">
                        <label className="form-label fw-semibold">الوزن (كغ)</label>
                        <input
                            type="number"
                            name="weight"
                            value={formData.weight}
                            onChange={handleChange}
                            className="form-control form-control-lg shadow-sm"
                        />
                        <div className="col-12 mt-2 text-center">
                            <button
                                className="btn btn-outline-secondary d-flex align-items-center justify-content-center"
                                onClick={fetchWeightHistory}
                            >
                                <FaHistory className="me-2"/> عرض تاريخ الوزن
                            </button>
                        </div>

                    </div>

                    <div className="col-md-3">
                        <label className="form-label fw-semibold">الطول (سم)</label>
                        <input
                            type="number"
                            name="height"
                            value={formData.height}
                            onChange={handleChange}
                            className="form-control form-control-lg shadow-sm"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label fw-semibold">هل أنت مدخن؟</label>
                        <select
                            name="smoker"
                            value={formData.smoker}
                            onChange={handleChange}
                            className="form-select form-select-lg shadow-sm"
                        >
                            <option value="لا">لا</option>
                            <option value="نعم">نعم</option>
                        </select>
                    </div>

                    <div className="col-md-6">
                        <label className="form-label fw-semibold">العمر</label>
                        <input
                            type="text"
                            name="age"
                            disabled={true}
                            value={formData.age}
                            className="form-control form-control-lg shadow-sm bg-light"
                        />
                    </div>

                    <div className="col-md-12">
                        <label className="form-label fw-semibold">الهدف من التمرين</label>
                        <input
                            type="text"
                            name="goal"
                            value={formData.goal}
                            onChange={handleChange}
                            className="form-control form-control-lg shadow-sm"
                        />
                    </div>

                    <div className="col-12">
                        <label className="form-label fw-semibold">ملاحظات صحية</label>
                        <textarea
                            name="health_notes"
                            value={formData.health_notes}
                            onChange={handleChange}
                            className="form-control shadow-sm"
                            rows="3"
                        />
                    </div>
                </div>

                <Modal
                    show={showWeightModal}
                    onHide={() => setShowWeightModal(false)}
                    size="lg"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>سجل تغييرات الوزن</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {weightHistory.length > 0 ? (
                            <table className="table table-bordered table-sm text-center">
                                <thead>
                                <tr>
                                    <th>الوزن القديم (كغ)</th>
                                    <th>الوزن الجديد (كغ)</th>
                                    <th>تاريخ التغيير</th>
                                </tr>
                                </thead>
                                <tbody>
                                {weightHistory.map((w, idx) => (
                                    <tr key={idx}>
                                        <td>{w.old_weight}</td>
                                        <td>{w.new_weight}</td>
                                        <td>{new Date(w.changed_at).toLocaleString()}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        ) : (
                            <p className="text-center mb-0">لا توجد تغييرات في الوزن.</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowWeightModal(false)}>
                            إغلاق
                        </Button>
                    </Modal.Footer>
                </Modal>



                <div className="mt-4 text-center">
                    <button
                        className="btn btn-primary btn-lg px-5 fw-bold shadow-sm"
                        onClick={handleSave}
                    >
                        حفظ التغييرات
                    </button>
                </div>
            </div>
        </div>
    );
}
